import { render } from "./InformacionPaciente.vue?vue&type=template&id=5b4023c1&scoped=true"
import script from "./InformacionPaciente.vue?vue&type=script&lang=js"
export * from "./InformacionPaciente.vue?vue&type=script&lang=js"

import "./InformacionPaciente.vue?vue&type=style&index=0&id=5b4023c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4023c1"]])

export default __exports__